/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(columns) {
  return columns.reduce(function (acc, col) {
    if (col.draggable !== false) {
      acc.stop = true;
    }
    if (col.draggable === false && !acc.stop) {
      acc.count++;
    }
    return acc;
  }, {
    count: 0
  }).count;
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/Layout/ColumnLayout/HeaderLayout/getUndraggableSuccessiveCount.js
// module id = 567
// module chunks = 0